import { useCheckForUpdates } from '@euler/functions/useCheckForUpdates';
import { memo } from 'react';

export const UpdatesCheck = memo(() => {
  useCheckForUpdates();
  return null;
});
